module.exports = __webpack_public_path__ + "img/poultrysciences-v-474x632.7eeda1f8.jpg";